import { createTheme } from '@mui/material/styles';


const themeName = 'deluxetheme1';

let theme = createTheme({
	palette:{
		primary: { main: '#01579B' },
  		secondary: { main: '#DFDFDF' }
	},
	// Add custom properties under a custom key
	simpleselect:{
		"& .MuiSelect-select": { padding: "0,50" }
	},
	"themeName": "Bahama Blue Porcelain Duck"
	
}, themeName);

export default theme;

//I suspect adaptV4Theme may not be needed.
//export default createTheme({ palette, themeName });
